"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SupportingCreativeType_1 = require("../../SupportingCreativeType");
class PricingMerchandiseBasic {
    constructor({ isResizable, isModificationRequestable, creativeType, }) {
        this.toJSON = () => ({
            isResizable: this.isResizable,
            isModificationRequestable: this.isModificationRequestable,
            creativeType: this.creativeType ? this.creativeType.toJSON() : undefined,
        });
        this.isResizable = isResizable;
        this.isModificationRequestable = isModificationRequestable;
        this.creativeType = creativeType;
    }
}
PricingMerchandiseBasic.fromJSON = (json) => {
    const { isResizable, isModificationRequestable, creativeType } = Object.assign({}, json);
    if (isResizable !== undefined && typeof isResizable !== 'boolean')
        throw new Error('.isResizable must be a boolean');
    if (isModificationRequestable !== undefined && typeof isModificationRequestable !== 'boolean')
        throw new Error('.isModificationRequestable must be a boolean');
    const _creativeType = creativeType ? SupportingCreativeType_1.default.fromJSON(creativeType) : undefined;
    return new PricingMerchandiseBasic({
        isResizable,
        isModificationRequestable,
        creativeType: _creativeType,
    });
};
exports.default = PricingMerchandiseBasic;
